import {Link} from 'react-router-dom'

import {APP_ROUTES} from '../../routes/routes'

const FooterMoreLinks = () => {
  const moreLinks = [
    {id: 'bonds', path: APP_ROUTES.BONDS, label: 'Investors'},
    {id: 'news', path: APP_ROUTES.NEWS, label: 'News'},
    {id: 'contacts', path: APP_ROUTES.CONTACTS, label: 'Contacts'}
  ]

  const links = moreLinks.map(({id, label, path}) => {
    return (
      <li className="footer-link" key={`footer-more-links-${id}`}>
        <Link to={path}>{label}</Link>
      </li>
    )
  })

  return (
    <ul>
      <li className="footer-link heading">More</li>
      {links}
    </ul>
  )
}

export default FooterMoreLinks
